"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SINGLE_PRODUCT = void 0;
var SINGLE_PRODUCT = {
  TEXT__CATEGORY: 'singleProduct-span-category',
  TEXT__NAME: 'singleProduct-span-name',
  TEXT__PRICE: 'singleProduct-span-price',
  TEXT__SKU: 'singleProduct-span-SKU',
  TEXT__DESCRIPTION: 'singleProduct-span-description',
  TEXT__TIER: 'singleProduct-span-tier',
  TEXT__TIER_FROM_TO: 'singleProduct-span-tierFromTo',
  TEXT__TIER_PRICE: 'singleProduct-span-tierPrice',
  TEXT__SUPPLIER_NAME: 'singleProduct-span-supplierName',
  BUTTON__SUPPLIER_INFO: 'singleProduct-button-supplierInfo',
  SUPPLIER_INFO_MODAL: {
    TEXT__TITLE: 'singleProductSupplierInfoModal-h3-title',
    BUTTON__EDIT: 'ingleProductSupplierInfoModal-button-edit',
    BUTTON__CLOSE: 'ingleProductSupplierInfoModal-button-close',
    INFO_PANEL: {
      TEXT__PRIMARY_CONTACT_NAME: 'singleProductSupplierInfoModal-span-primaryContactName',
      TEXT__PRIMARY_CONTACT_PHONE: 'singleProductSupplierInfoModal-span-primaryContactPhone',
      TEXT__ADDRESS: 'singleProductSupplierInfoModal-span-address',
      TEXT__CUSTOM_INFO: 'singleProductSupplierInfoModal-span-customInfo',
      TEXT__EMAIL: 'singleProductSupplierInfoModal-a-email',
      TEXT__MINIMUM_ORDER_AMOUNT: 'singleProductSupplierInfoModal-span-minimumOrderAmount',
      TEXT__DELIVERY_FEE: 'singleProductSupplierInfoModal-span-deliveryFee',
      TEXT__WORKING_HOURS_LABEL: 'singleProductSupplierInfoModal-span-workingHoursLabel',
      TEXT__WORKING_HOURS: 'singleProductSupplierInfoModal-span-workingHours',
      TEXT__DELIVERY_PERIOD: 'singleProductSupplierInfoModal-span-deliveryPeriod',
      TEXT__SHIPPING_ADDRESS: 'singleProductSupplierInfoModal-span-shippingAddress',
      TEXT__BILLING_ADDRESS: 'singleProductSupplierInfoModal-span-billingAddress'
    }
  },
  BUTTON__ADD_TO_CART: 'singleProduct-button-addToCart',
  INPUT__QUANTITY: 'singleProduct-input-quantity',
  TEXT__ORDERING_UNIT: 'singleProduct-span-orderingUnit',
  TEXT__TOTAL_PRICE: 'singleProduct-span-totalPrice'
};
exports.SINGLE_PRODUCT = SINGLE_PRODUCT;